module.exports = __webpack_public_path__ + "img/abstract01.7553bff8.jpeg";